// extracted by mini-css-extract-plugin
export default {"badges":"AgentBadges_badges__WC3Dr","badge":"AgentBadges_badge__BH7ud","badgeGreen":"AgentBadges_badgeGreen__8HrPO"};